import { createServerFn } from "@tanstack/react-start";
import { readDocumentPage } from "../server/document.server";
import { siteContext } from "../server/site.server";
import { legalPage } from "./legal.server";
import { platformPageResponse } from "./page-response";
import { regularPlanShown } from "./plan-flag.server";

/**
 * /privacy and /terms: on a creator's site, the creator's policy page (theirs, or Drate's default
 * until they customize it); on Drate's own host, Drate's Terms or Privacy.
 */
export const loadPolicyPage = createServerFn({ method: "GET" })
  .validator((path: unknown) => {
    if (path !== "/privacy" && path !== "/terms") throw new Error("Pass a policy page.");
    return path;
  })
  .handler(async ({ data: path, context }) => {
    const drate = await siteContext(context);
    if (drate.creator) return readDocumentPage(drate, path);
    platformPageResponse(drate);
    return legalPage(path, await regularPlanShown(drate));
  });
